module.exports = __webpack_public_path__ + "static/media/koryu_00012.d24dc2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/koryu_00012.png
// module id = 265
// module chunks = 0